module.exports = __webpack_public_path__ + "img/smtp.51bdc4b2.svg";